import React from "react";
import ReactDOM from "react-dom";
import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/ie11"; // For IE 11 support
import Root from "./containers/Root";
import "./index.css";

ReactDOM.render(<Root />, document.getElementById("root"));

// The build no longer generates the CRA-era Workbox service worker; actively
// unregister it so browsers that installed one stop serving stale assets.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    registration.unregister();
  });
}
